/*
 * Copyright Thoughtworks, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export enum TristateState {
  on, off, indeterminate
}

export class TriStateCheckbox {
  private readonly initialState: TristateState;
  private currentState: TristateState;
  private disabled: boolean;

  constructor(initialState: TristateState = TristateState.indeterminate, disabled = false) {
    this.initialState = initialState;
    this.currentState = initialState;
    this.disabled = disabled;
  }

  click() {
    if (this.initialState === TristateState.indeterminate) {
      // cycle through all states
      this.currentState = (this.currentState + 1) % 3;
    } else {
      if (this.currentState === TristateState.off) {
        this.currentState = TristateState.on;
      } else {
        this.currentState = TristateState.off;
      }
    }
  }

  isChecked() {
    return this.currentState === TristateState.on;
  }

  isIndeterminate() {
    return this.currentState === TristateState.indeterminate;
  }

  isUnchecked() {
    return this.currentState === TristateState.off;
  }

  ischanged() {
    return this.initialState !== this.currentState;
  }

  state() {
    return TristateState[this.currentState];
  }

  isDisabled(): boolean {
    return this.disabled;
  }
}
